/**
 * EventModifier options for registration on map-event-manager.
 */
export enum CesiumEventModifier {
  ALT = Cesium.KeyboardEventModifier.ALT,
  CTRL = Cesium.KeyboardEventModifier.CTRL,
  SHIFT = Cesium.KeyboardEventModifier.SHIFT,
}
